import { GameLogger } from "@/game/utils/gameLogger";
import { Howl } from "howler";

// Import audio files so Bun bundles them
import checkerMoveSound from "@/assets/audio/checker-move-min.mp3";
import diceRollSound from "@/assets/audio/dice-roll-min.mp3";
import gameLostSound from "@/assets/audio/game-lost-min.mp3";
import gameStartSound from "@/assets/audio/game-start-min.mp3";
import gameWonSound from "@/assets/audio/game-won-min.mp3";

const sounds = {
  "dice-roll": new Howl({ src: [diceRollSound], volume: 0.5 }),
  "checker-move": new Howl({ src: [checkerMoveSound], volume: 0.5 }),
  "game-won": new Howl({ src: [gameWonSound], volume: 0.5 }),
  "game-lost": new Howl({ src: [gameLostSound], volume: 0.5 }),
  "game-start": new Howl({ src: [gameStartSound], volume: 0.5 })
};

let isMuted = false;

export function playSound(soundName: keyof typeof sounds) {
  if (isMuted) {
    GameLogger.logInfo("Audio", `Sound muted: ${soundName}`);
    return;
  }

  try {
    const sound = sounds[soundName];
    if (!sound) {
      GameLogger.logError("Audio", `Sound not found: ${soundName}`);
      return;
    }

    // For dice-roll sound specifically, stop any currently playing instance
    // to prevent overlapping sounds creating the scratching noise
    // TODO: this is a hack until we can fix gameRect causing unncessary re-renders
    if (soundName === "dice-roll" && sound.playing()) {
      GameLogger.logInfo("Audio", "Stopping existing dice-roll sound before playing new one");
      sound.stop();
    }

    sound.play();
  } catch (error) {
    GameLogger.logError("Audio", `Failed to play ${soundName}:`, error);
  }
}

export function setMuted(muted: boolean) {
  isMuted = muted;
}
